import React from "react";
import "./GeographicalCoverageStyle.scss";
import { geographicalCoverageTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const GeographicalCoverageSection = () => {
  return (
    <section className="geographical-coverage-section">
      <div className="geographical-coverage-wrap">
        <SectionHeading>{geographicalCoverageTextContent.headingText}</SectionHeading>

        <div className="geographical-coverage-box">
          <div className="img-box">
            <img src={geographicalCoverageTextContent.imageSrc} alt="Image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GeographicalCoverageSection;
